import {ENDPOINTS_LOANS} from 'common/endpoints/loans.endpoints';

export default class LoansRepaymentService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  createTotalRepayment(repaymentParams) {
    const repayment = {
      loanId: repaymentParams.loanId,
      identifying: parseInt(repaymentParams.loan.identifying, 10),
      amount: repaymentParams.repaymentAmount,
      capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate
    };

    return this.http.post(ENDPOINTS_LOANS.post.createTotalRepayment(repaymentParams.employeeId), { amortizations: [repayment] });
  }

  createPartialRepayment(repaymentParams, feePeriod) {
    const repayment = {
      loanId: repaymentParams.loanId,
      identifying: parseInt(repaymentParams.loan.identifying, 10),
      amount: repaymentParams.amount,
      capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate,
      feePeriod: feePeriod
    };

    return this.http.post(ENDPOINTS_LOANS.post.createPartialRepayment(repaymentParams.employeeId), { amortizations: [repayment] });
  }

  simulateRepayment(repaymentParams, feePeriod){
    const repayment = {
      loanId: repaymentParams.loanId,
      identifying: parseInt(repaymentParams.loan.identifying, 10).toString(),
      amount: repaymentParams.repaymentAmount,
      capitalMovementTypeDate: repaymentParams.capitalMovementTypeDate,
      feePeriod: feePeriod
    };

    return this.http.post(ENDPOINTS_LOANS.post.simulateRepayment(repaymentParams.employeeId), repayment );
  }

}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepayment.service.js